import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${theme.spacing.md};
  gap: ${theme.spacing.md};
`

export const ActionsRow = styled.div`
  padding-top: ${theme.spacing.md};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
`
